export const UIColors = {
    grayish: "#323633",
    blackish: "#1e211f",
    accent: "#F05343",
    border: "#dadce0"
}